import { Navigate, Route, Routes } from "react-router-dom";
import { routes, userRoles } from "../../../constants";
import AuthLayout from "../../../component/common/layouts/auth/AuthLayout";
import MainLayout from "../../../component/common/layouts/main/MainLayout";
import userLayouts from "../../../constants/userLayoutsConsts";
import renderProtectedRoutes from "./renderProtectedRoutes";
import renderNoLayoutRoutes from "./renderNoLayoutRoutes";
import {
  baseRouteMaker,
  baseRouteMakerForSuperAdmin,
} from "../../../constants/routeConsts";
import {
  AddBankAccount,
  ForgotPassword,
  ForgotPasswordVerification,
  NewPassword,
  OtpVerificationEmail,
  OtpVerificationPhone,
  ResetPassword,
  SignIn,
  SignUp,
} from "../../../component/pages/service-provider-admin";
import useLocalStorage from "../../../hooks/useLocalStorage";
import { appConfig } from "../../../constants/config/appConfig";

const RenderServiceProviderAdminRoutes = () => {
  const { userSession } = useLocalStorage(appConfig.SESSION_USER_INFO);

  const renderDashboardBasedOnRoles = {
    [userRoles.SERVICE_PROVIDER_ADMIN]: baseRouteMaker(routes.DASHBOARD),
    [userRoles.SERVICE_PROVIDER_ADMIN_ROLES.REGULAR_STAFF]: baseRouteMaker(
      routes.STAFF_DASHBOARD
    ),
    [userRoles.SERVICE_PROVIDER_ADMIN_ROLES.MEDICAL_STAFF]: baseRouteMaker(
      routes.STAFF_DASHBOARD
    ),
    [userRoles.SERVICE_PROVIDER_ADMIN_ROLES.DOCTOR]: baseRouteMaker(
      routes.STAFF_DASHBOARD
    ),
    [userRoles.SUPER_ADMIN_ROLES.ACCOUNTANT]: baseRouteMakerForSuperAdmin(
      routes.FUND_MANAGEMENT
    ),
    [userRoles.SUPER_ADMIN_ROLES.CUSTOMER_SUPPORT]: baseRouteMakerForSuperAdmin(
      routes.TICKET_MANAGEMENT
    ),
  };

  const userRoleRoute = renderDashboardBasedOnRoles[userSession?.userRole];
  const defaultRoute = baseRouteMaker(routes.SIGN_IN);
  return (
    <>
      <Routes>
        <Route
          path={routes.DEFAULT_BASE_REDIRECT}
          element={<Navigate to={baseRouteMaker(routes.SIGN_IN)} replace />}
        />
        {/* public routes */}
        <Route element={<AuthLayout />}>
          <Route path={routes.SIGN_IN} element={<SignIn />} />
          <Route path={routes.SIGN_UP} element={<SignUp />} />
          <Route
            path={routes.OTP_VERIFICATION_PHONE}
            element={<OtpVerificationPhone />}
          />
          <Route
            path={routes.OTP_VERIFICATION_EMAIL}
            element={<OtpVerificationEmail />}
          />
          <Route path={routes.SET_NEW_PASSWORD} element={<NewPassword />} />
          <Route path={routes.FORGOT_PASSWORD} element={<ForgotPassword />} />
          <Route
            path={routes.FORGOT_PASSWORD_VERIFICATION}
            element={<ForgotPasswordVerification />}
          />
          <Route path={routes.ADD_BANK_ACCOUNT} element={<AddBankAccount />} />
          <Route path={routes.RESET_PASSWORD} element={<ResetPassword />} />
        </Route>

        {/* public routes */}

        {/* protected routes */}
        <Route element={<AuthLayout />}>
          {renderProtectedRoutes(userLayouts.IS_AUTH)}
        </Route>

        <Route path="/" element={<MainLayout />}>
          <Route
            path="/"
            element={<Navigate to={userRoleRoute || defaultRoute} />}
          />
          {renderProtectedRoutes(userLayouts.IS_MAIN)}
        </Route>

        {renderNoLayoutRoutes()}
        {/* protected routes */}
      </Routes>
    </>
  );
};

export default RenderServiceProviderAdminRoutes;
